var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data,"footer-props":{
      disableItemsPerPage: true,
      itemsPerPageText: '',
      itemsPerPageOptions: [],
      disablePagination: true
    }},scopedSlots:_vm._u([{key:`item.triggeredFromNetTraffic`,fn:function({ item }){return [_c('td',[_c('strategy-report-value',{attrs:{"value":item.triggeredFromNetTraffic,"breakpoint":"20"}})],1)]}},{key:`item.conversionToolEnqFromUniqueNetTraffic`,fn:function({ item }){return [_c('td',[_c('strategy-report-value',{attrs:{"value":item.conversionToolEnqFromUniqueNetTraffic,"breakpoint":"0.1"}})],1)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }